import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { fiatCurrencyList } from './singFiatCurrency';
import { UtilsLocalStorage } from 'services';

export const convert = (amount, fromCurrency, toCurrency) => {
    let currencies = {};

    try {
        currencies = JSON.parse(UtilsLocalStorage.getItem('currencies')) || {};
    } catch (err) {
        console.error({ UtilsLocalStorage: err });
    }

    const to = currencies[toCurrency] || 1;
    const from = currencies[fromCurrency] || 1;
    return Decimal.div(amount, from).mul(to).toNumber();
};

export const convertCrypto = (amount, fromCurrency, toCurrency): number => {
    let _toCurrency = toCurrency;
    if (!fiatCurrencyList.includes(toCurrency)) {
        _toCurrency = 'USD';
    }
    return convert(amount, fromCurrency, _toCurrency);
};

export const useConvertCrypto = (amount, fromCurrency, toCurrency) => {
    return useMemo(() => convertCrypto(amount, fromCurrency, toCurrency), [amount, fromCurrency, toCurrency]);
};